module.exports = __webpack_public_path__ + "img/icon_theme.cac867d.svg";